import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DegreeAttestEduService {
  public educationData:any;
  constructor() { }

  public setEducationData(data):void{
    this.educationData = data;
  }
}
